import { render, staticRenderFns } from "./themes-tab-loader.vue?vue&type=template&id=71e977b6"
import script from "./themes-tab-loader.vue?vue&type=script&lang=js"
export * from "./themes-tab-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports